"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dataLayerPush = dataLayerPush;

var _reactCookies = _interopRequireDefault(require("react-cookies"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ABNtest = 'ABNtest';
/**
 * Отправка события в GA
 * @example
 * dataLayerPush({event: 'UAevent', category: 'sale', action: 'get gift'});
 * @param {JSON} params параметры события
 *
 * @deprecated
 */

function dataLayerPush(params) {
  window.dataLayer = window.dataLayer || [];
  var label = params.label || '';
  params[ABNtest] = _reactCookies["default"].load('abn_variant');

  var dataLayerParams = _objectSpread(_objectSpread({}, params), {}, {
    label: label
  });

  window.dataLayer.push(dataLayerParams);
}